import React, { useContext } from "react";
import { MenuContext } from "../context/menuContext";

function Settings() {
	const { mobileMenu } = useContext(MenuContext);

	return (
		<div
			className={
				mobileMenu
					? "overflw-y-hidden absolute md:left-64 md:top-0 w-screen md:w-[calc(100%-16rem)] py-3 h-screen bg-slate-50 dark:bg-darkbg"
					: "absolute md:left-64 md:top-0 w-screen md:w-[calc(100%-16rem)] py-3 h-screen top-[3rem] bg-slate-50 dark:bg-darkbg"
			}>
			<div className="flex justify-between items-baseline px-5 border-b border-b-slate-100 dark:border-darkborder">
				<h1 className="mb-3 text-slate-500 dark:text-darktext uppercase font-semibold">
					Settings
				</h1>
			</div>
		</div>
	);
}

export default Settings;
